import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingPorkFeedProduction, setFootprintingPorkFeedProductionAdmin } from "services";

import { footprintingPorkPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PORK_FEED_PRODUCTION } from "consts";

import { PorkFeedProduction } from "models";

export const useMutateFootprintingPorkFeedProduction = (
  feedInformationId: string,
  primaryDataId: string,
  farmId: string,
  year: number,
  onSuccess?: () => void
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PORK_FEED_PRODUCTION, feedInformationId, isAdmin],
      mutationFn: (data: PorkFeedProduction) =>
        isAdmin ? setFootprintingPorkFeedProductionAdmin(feedInformationId, data) : setFootprintingPorkFeedProduction(feedInformationId, data),
      onSuccess: async () => {
        await invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_PORK_FEED_PRODUCTION, feedInformationId, isAdmin],
          ...footprintingPorkPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
        ]);
        onSuccess?.();
      },
    },
    queryClient
  );
};
